"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { useEffect } from "react";

function ScrollToTopOnRouteChange() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname, searchParams.toString()]);

  return null;
}

export default ScrollToTopOnRouteChange;
